@if (collectionCaseCompositeEntities()?.length && chartOptions) {
  <div class="chart-wrapper text-right" style="width: 100%">
    <div class="d-flex align-items-top justify-content-between mb-4">
      <div>{{ 'company_page.payment_remarks_card.historical_chart' | translate }}</div>
      @if (printVersion()) {
        <div>
          @if (chartType === 'quantity') {
            {{ 'company_page.payment_remarks_card.chart.quantity' | translate }}
          }
          @if (chartType === 'sum') {
            {{ 'company_page.payment_remarks_card.chart.sum' | translate }}
          }
        </div>
      }
      <div class="btn-group text-right" role="group" [hidden]="printVersion()">
        <button
          nkButton
          [color]="chartType === 'quantity' ? 'primary' : 'secondary'"
          size="xs"
          (click)="changeChartType('quantity')">
          {{ 'company_page.payment_remarks_card.chart.quantity' | translate }}
          @if (chartType === 'quantity') {
            <i class="fa fa-check ms-2"></i>
          }
        </button>
        <button
          nkButton
          [color]="chartType === 'sum' ? 'primary' : 'secondary'"
          size="xs"
          (click)="changeChartType('sum')">
          {{ 'company_page.payment_remarks_card.chart.sum' | translate }}
          @if (chartType === 'sum') {
            <i class="fa fa-check ms-2"></i>
          }
        </button>
      </div>
    </div>
    <highcharts-chart
      [Highcharts]="highcharts"
      [options]="chartOptions"
      style="display: block; margin: 0"
      [ngStyle]="{
        height: '200px',
        width: '100%',
        maxWidth: printVersion() ? '160mm' : undefined,
      }"
      [runOutsideAngular]="true"
      [(update)]="columnUpdateFlag"
      [oneToOne]="true"></highcharts-chart>
  </div>
}
